// Shared limits and defaults. Names carry their unit.

/** FR-CAP-01: instant replay window. */
export const REPLAY_BUFFER_MS = 120_000;
export const MAX_CONSOLE_ENTRIES = 500;
export const MAX_CONSOLE_ENTRY_BYTES = 8 * 1024;
export const MAX_NETWORK_ENTRIES = 300;
/** FR-CAP-08, NFR-PERF-01: in-memory size of all buffered network entries (UTF-16 estimate). */
export const MAX_NETWORK_BUFFER_BYTES = 8 * 1024 * 1024;
export const MAX_ACTION_ENTRIES = 2_000;
/** Soft cap; the replay buffer trims at a Meta+FullSnapshot boundary and hard-stops at 2x. */
export const MAX_REPLAY_EVENTS = 20_000;
/** FR-NET-03: per request or response body. */
export const MAX_BODY_BYTES = 64 * 1024;
/** Long-lived text streams emit what they have after this long. */
export const BODY_READ_TIMEOUT_MS = 10_000;
export const REPLAY_CHECKOUT_MS = 30_000;
export const SCROLL_THROTTLE_MS = 100;

/** FR-PRIV-03: header names always redacted, in addition to sensitive key matching. */
export const DEFAULT_REDACT_HEADERS = ["authorization", "cookie", "set-cookie", "x-api-key"];
/** FR-PRIV-03: sensitive key terms, matched as normalized substrings (`client_secret`, `card[cvc]`). */
export const DEFAULT_REDACT_KEYS = [
  "password",
  "passwd",
  "secret",
  "token",
  "apiKey",
  "authorization",
  "cookie",
  "session",
  "credential",
  "privateKey",
  "cardNumber",
  "cvv",
  "cvc",
  "csrf",
  "xsrf",
  "passcode",
  "passphrase",
  "jwt",
  "accessKey",
  "privkey",
  "bearer",
  "samlResponse",
];
/**
 * FR-PRIV-03: short sensitive terms matched only as whole words of a key (`otp`, `OTPCode`,
 * `user_ssn`, `authKey`, `X-Amz-Signature`), so `author`, `footprint` and `spinner` stay readable.
 */
export const DEFAULT_REDACT_KEY_WORDS = [
  "auth",
  "otp",
  "totp",
  "mfa",
  "ssn",
  "pin",
  "pwd",
  "pass",
  "signature",
  "sig",
  "sid",
];

// Report upload limits (media-and-compression.md, ingest pipeline in api.md).
const MIB = 1024 * 1024;
/** Whole multipart request. */
export const MAX_REPORT_BYTES = 200 * MIB;
export const MAX_PAYLOAD_PART_BYTES = 256 * 1024;
export const MAX_VIDEO_BYTES = 150 * MIB;
export const MAX_SCREENSHOT_BYTES = 15 * MIB;
export const MAX_THUMBNAIL_BYTES = 256 * 1024;
/** One compressed capture file (replay, console, network, actions). */
export const MAX_CAPTURE_FILE_BYTES = 25 * MIB;
/** Zip-bomb guard: a replay file may not decompress beyond this. */
export const MAX_DECOMPRESSED_BYTES = 50 * MIB;
/**
 * Console, network and actions files unpacked. The recorder keeps at most about 4 MiB of console and
 * 8 MiB of network, so 16 MiB leaves room while bounding the memory one upload costs.
 */
export const MAX_LOG_DECOMPRESSED_BYTES = 16 * MIB;
/** Uploads processed at once per API process; the rest wait in a short queue. */
export const MAX_CONCURRENT_INGESTS = 2;
export const MAX_QUEUED_INGESTS = 20;
/** FR-VID-01: 15 minutes. */
export const MAX_VIDEO_MS = 15 * 60 * 1000;
/** Request ids kept per report for search. */
export const MAX_REPORT_REQUEST_IDS = 200;
/** Redacted error text kept per report for search. */
export const MAX_ERROR_TEXT_CHARS = 4096;
